import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Teach tailwind-merge about the editorial custom border-radius scale so that a
// later `rounded-input` correctly overrides a base `rounded-pill` (e.g. select
// triggers built on Button). Without this, both classes survive and CSS source
// order — not className order — decides, which renders selects as pills.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      rounded: [{ rounded: ["pill", "input", "card", "tag", "chip"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
